// cameraSync.ts — one orbit camera shared by side-by-side viewers, so two
// commits' splats can be compared from the same viewpoint. A viewer
// publishes its camera when the user moves it and applies whatever the
// others publish; the source id keeps a viewer from re-applying its own move.
import type { OrbitState } from '../../../../openscan/web/src/splat/orbit';

type Listener = (state: OrbitState, source: string) => void;

export class CameraSync {
  private listeners = new Set<Listener>();
  /** The last published camera, so a viewer that mounts late can join it. */
  state: OrbitState | null = null;

  publish(state: OrbitState, source: string): void {
    this.state = { ...state, target: [...state.target] as OrbitState['target'] };
    for (const l of this.listeners) l(this.state, source);
  }

  subscribe(l: Listener): () => void {
    this.listeners.add(l);
    return () => {
      this.listeners.delete(l);
    };
  }
}
